module.exports = __webpack_public_path__ + "static/media/25586789_1703510176390833_2697717958984606722_o.66bc3569.jpg";